import { useCallback, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { ComponentWithPermissions } from '../../../../../../../../../../baseComponents/CreateRoutering/types'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { SubtitleMultipleCbxSelector } from '../../../../../../../../../../forms/MultipleCheckboxSelector/types'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { Features, FeaturesPayload } from '../../../../../../../../../../utils/reducers/products/features'
import { ProductExtendedTyShort } from '../../../../../../../../../Product/types'


type FeaturesProductQuoteTabProps = ComponentWithPermissions & FeaturesLogicProductProps & {
    getData: () => Promise<void>
}

const FeaturesProductQuoteTab: React.FC<FeaturesProductQuoteTabProps> = ({ basicData, getData, userPermissions, features, ...rest }) => {
    const { selectedFeatures } = useFeaturesLogicProduct({ features, basicData, ...rest })
    if (!features || !basicData) {
        return null
    }
    return (
        <div className='flex flex-auto h-1 flex-col product_container modal_negative_margin '>
            <div className='px-30'>
                {selectedFeatures && Object.keys(selectedFeatures).length ? <RenderFeatures features={features} selectedFeatures={selectedFeatures} /> : <div><TwinTrans transKey={'notHaveFeatures'}>No tiene características</TwinTrans> </div>}
            </div>
        </div>
    )
}

interface FeaturesLogicProductProps extends ReduxFeatures {
    basicData: ProductExtendedTyShort | null
}

export type SelectedFeaturesTy = { [FeatureId: string]: number[] }

const useFeaturesLogicProduct = ({ features, basicData }: FeaturesLogicProductProps) => {
    const ProductId = basicData?.id
    const [selectedFeatures, setSelectedFeatures] = useState<SelectedFeaturesTy>({})

    const getSelectedFeatures = useCallback(async () => {
        if (features) {
            const featuresValuesProduct = await twinFetchPostJSON('/api/app/product/getFeatureValuesOfProduct', { ProductId })
            setSelectedFeatures(featuresValuesProduct)
        }
    }, [features, ProductId])

    useEffect(() => {
        getSelectedFeatures()
    }, [getSelectedFeatures])

    return { selectedFeatures }
}

interface RenderFeaturesProps {
    features: Features
    selectedFeatures: SelectedFeaturesTy
}

const RenderFeatures: React.FC<RenderFeaturesProps> = ({ features, selectedFeatures }) => {
    const { t } = useTwinTranslation()
    const renderThis: JSX.Element[] = []
    if (features) {
        const subtitles: SubtitleMultipleCbxSelector = {
            subtitleOptions: t('allFeatures', 'Todas las características'),
            subtitleSelectedOptions: t('selectedFeatures', 'Características seleccionadas')
        }

        for (const key in selectedFeatures) {
            const fields: FormRender<any> = [
                {
                    cols: 1,
                    elements: [
                        {
                            name: '',
                            component: 'MultipleCheckboxSelector',
                            subtitles: subtitles,
                            items: features[key]?.values || [],
                            defaultValue: selectedFeatures[key],
                            readOnly: true
                        }
                    ]
                }
            ]
            renderThis.push(
                <div className='my-30' key={features[key]?.id}>
                    <div className='flex justify-between items-center'>
                        <span className='medium14 uppercase'>{features[key]?.name}</span>
                    </div>
                    <FormRenderer sections={fields} antiUnsaveTrigger={true} />
                </div>
            )
        }
    }
    return (
        <div>
            {renderThis}
        </div>
    )
}

const featuresProductDispatch = {
    setFeatures: (payload: FeaturesPayload) => ({ type: 'CHANGE_FEATURES', payload }),
}

const mapFeaturesConnector = (state: AllReduxPayloads) => ({ features: state.features })
const featuresConnect = connect(mapFeaturesConnector, featuresProductDispatch)
export type ReduxFeatures = ConnectedProps<typeof featuresConnect>

const featuresConnectLoading = withLoading(FeaturesProductQuoteTab, [{ fetchUrl: '/api/app/product/feature/getAllFeaturesComplete', propName: 'features', setFunctionName: 'setFeatures' }])

const FeaturesProductQuoteTabConnect = featuresConnect(featuresConnectLoading)

export default FeaturesProductQuoteTabConnect